import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filters", "list"]

  filter(event: Event) {
    const button = event.currentTarget as HTMLButtonElement
    const type = button.dataset.voterListAiWarningsFilterTypeParam

    // Update active button
    this.filtersTarget.querySelectorAll("button").forEach((btn: Element) => {
      btn.classList.remove("voter-list__ai-warnings__filter-btn--active")
    })
    button.classList.add("voter-list__ai-warnings__filter-btn--active")

    // Filter items
    this.listTarget.querySelectorAll<HTMLElement>(".voter-list__ai-warnings__item").forEach((item) => {
      if (type === "all" || item.dataset.warningType === type) {
        item.style.display = ""
      } else {
        item.style.display = "none"
      }
    })
  }

  declare filtersTarget: HTMLElement
  declare listTarget: HTMLElement
}
